
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import TruthReport from './components/TruthReport';
import Network from './components/Network';
import ReporterProgramCTA from './components/ReporterProgramCTA';
import LiveSite from './components/LiveSite';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <About />
      <Services />
      <TruthReport />
      <Network />
      <LiveSite />
      <ReporterProgramCTA />
      <Footer />
    </div>
  );
}
